
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import { formatUpyunUrl } from "@/utils";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd, getFaqJsonLd, injectJsonLd } from "@/utils/seo";
// import {openJesongChat} from "easy"

@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class Emba extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "实战EMBA总裁班 | 光华共创会×香港光华管理学院 - 光华赋能",
      description:
        "光华共创会与香港光华管理学院联合发起实战EMBA总裁班，旨在培养专业的企业老板，做中国最落地、最接地气的实战EMBA。面向企业负责人、联合创始人，系统学习经营管理实战课程。",
      keywords:
        "实战EMBA,EMBA总裁班,光华共创会,香港光华管理学院,企业老板培训,创始人培训,经营管理,光华赋能",
      path: "/emba",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "共创会" },
        { name: "实战EMBA" }
      ],
      jsonLd: getServiceJsonLd({
        name: "实战EMBA总裁班",
        description:
          "光华共创会与香港光华管理学院联合发起的实战EMBA总裁班，面向企业负责人与联合创始人，提供落地的经营管理实战课程。",
        category: "EMBA总裁培训"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/ae226bdec7b070be088210f70918a109.png";
  pic2 = "/img/8522c5d71b5ffc1bb80ce0fad657bb5f.png";
  pic3 = "/img/6529b831155d0b7dd37ffed0c4271aae.png";
  companyArr: any = [];
  List = [
    { title: "共创会", url: "" },
    { title: "实战EMBA", url: "" }
  ];
  created() {
    this.initData();
  }
  initData() {
    let companyArr0 = [];
    let companyArr1 = [];
    //  emba-activity2
    for (let index = 1; index < 8; index++) {
      companyArr0.push("/gh_website/emba-activity" + index + ".png");
    }
    for (let index = 8; index < 17; index++) {
      companyArr1.push("/gh_website/emba-activity" + index + ".png");
    }
    this.companyArr.push(companyArr0);
    this.companyArr.push(companyArr1);
    console.log("companyArr", this.companyArr);
  }
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "共创会，大思维书院，实战EMBA，EMBA，常青藤"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业老板，专业的老板,实战EMBA,总裁班,学东西，交朋友，整资源，提升业务，企业负责人,联合创始人,企业接班人,大思维书院说明：标杆企业家,终身说明，前沿趋势，提升思维，思维层次，终身学习，大思维，科学经营底座，高质量发展常青藤说明：新生代企业家，传承接力，破局求变，转型升级，户外拓展，企业家私董会，共创会EMBA校友日，校友日，共创会年度高峰论坛，高峰论坛，论坛，精品研学，同学小聚"
    );
    document.head.appendChild(metaTag2);
    // 注入 FAQPage JSON-LD
    injectJsonLd(
      "jsonld-faq",
      getFaqJsonLd([
        {
          question: "共创会EMBA是什么？和传统EMBA有什么区别？",
          answer: "共创会EMBA是香港光华管理学院旗下、由方永飞教授发起的高端企业家实战型工商管理课程与学习社群，以「培养专业的老板」为使命，依托「科学经营12349系统框架」和「65420课程体系」，通过18个月系统学习+实战训战+高端圈层，帮助企业创始人将知识、经验、技能融合为实战能力，推动企业实现结构性增长。共创会EMBA的口号是「学东西、交朋友、整资源、增业务」，它不仅是一个课程，更是一个高质量的企业家发展共同体。与传统EMBA的核心区别：第一，实战导向vs理论导向——传统EMBA多由高校举办，课程体系偏理论化，教授多为学院派，案例偏国际大型企业；共创会EMBA的16位核心讲师均为各领域实战专家，包括上市公司高管、集团财务总监、小米原副总裁、阿里原省总经理等，课程内容、工具方案均经过大量企业落地验证，强调「训战结合、实操导向」，包含4堂实操课。第二，体系完整vs学科拼盘——传统EMBA课程往往是经济学、管理学、营销学、财务学等学科的拼盘；共创会EMBA以科学经营「12349」系统框架为统一底座，围绕「天（战略）、法（营销）、地（股权）、道（人力/财务/领导力）」四大根基设计六大核心模块，课程之间逻辑严密、体系完整。第三，圈层精准vs人员混杂——传统EMBA学员背景多样，圈层质量参差不齐；共创会EMBA采用审核制准入，学员以年销3000万以上企业决策者为主，相当比例学员企业年营收破亿，圈层精准、质量高。第四，长期陪跑vs课程结束即散伙——传统EMBA学制结束后学员联系逐渐减少；共创会EMBA提供18个月全周期系统学习+终身校友权益+课程永久复训+业绩增长辅导，是长期陪伴企业成长的高质量发展共同体。"
        },
        {
          question: "65420课程体系具体包含什么？",
          answer: "65420课程体系是共创会EMBA的核心课程架构，2025年10月聚焦增长推出，旨在通过系统化的课程设计帮助企业家构建完整的经营管理能力。6堂必修课——系统搭建科学经营知识框架，围绕科学经营「12349」系统框架和四大根基（天法地道）设计，覆盖战略、营销、股权、人力、财务、领导力六大核心模块，由方永飞老师及核心实战专家授课，是所有学员必须完成的核心课程。5堂案例课——真实企业案例深度研讨，选取光华服务过的真实企业案例，涵盖不同行业、不同发展阶段、不同典型问题的企业，由案例企业创始人或光华咨询师现场深度拆解，学员通过案例研讨学习标杆企业的成功经验和失败教训，看样学样，加快自身企业的落地进程。4堂实操课——动手实操，工具方法直接落地，采用「训-战-练」模式，训练企业家和企业高管的操盘思维，学员在课堂上以自己企业为案例，动手实操18大落地工具和36个关键数据指标，包括BSC大表、行动方案表、绩效合约表、股权设计模板、识人面试模型等，采用小组PK制实战学习，按行业分组、沙龙式教学，确保学员带回企业可直接应用的工具方案。20堂选修课——前沿课题按需选修，覆盖全域营销、爆品打造、企业出海、AI应用、新媒体运营、IP矩阵、财税合规、精益生产等前沿和专项课题，学员可根据自身企业的行业特点和发展需求按需选修，选修课保持高频更新，纳入AI+智能体、AI全域营销、新媒体IP矩阵等前沿课题。学制与考核：共创会EMBA学制18个月，教学采用「课程→实战→迭代→复盘」闭环模式，实行学分制管理，考试+作业双重考核，严格考勤规则，学员完成必修、案例、实操课程并通过考核后，可获得香港光华管理学院官方结业证书。"
        },
        {
          question: "共创会EMBA的报名条件和流程是怎样的？",
          answer: "共创会EMBA采用审核制准入，对报名者有明确的条件要求和规范的报名流程。报名条件：1.身份要求——企业创始人、董事长、总经理等核心决策层，非企业决策层的职业经理人不在招生范围内（更适合企业内训或专项技能课程）。2.企业规模要求——企业年销售额3000万以上，这是审核制的核心门槛，具体以招生老师评估为准，相当比例学员企业年营收破亿，企业规模过小（年销3000万以下）的早期创业者建议先从大增长营等入门产品入手。3.推荐信要求——需提交推荐信，由共创会EMBA导师、实践辅导员或共创会会员填写并手写签名，推荐信是申请共创会EMBA的必备文件，没有推荐信无法通过初审进入面试环节，推荐人需手写签名后由申请者快递原件至共创会EMBA审核委员会。4.学习意愿要求——愿意投入时间参与线下学习、实操演练和社群活动，只想拿证书、混圈子，不愿真学实干的人不适合；追求短期暴利、投机心态的人也不适合。报名流程（六步）：1.第一步：提交申请材料——提交共创会EMBA入学申请表和推荐信，缴纳报名费2000元（可抵扣学费）。2.第二步：资格审核与面试——学院进行资格审核，通过初选者进入面试环节，面试时签署纪律认同等承诺书，面试主要考察申请者的企业经营状况、学习动机、价值观匹配度等。3.第三步：录取——通过面试者获得香港光华管理学院颁发的共创会EMBA入学通知书。4.第四步：签署协议——签署《共创会EMBA入学协议》，明确双方权利义务和学习纪律。5.第五步：缴纳学费——建增长对接群，注册线上学习平台「微学」账号，开通线上学习权限。6.第六步：开启学习之旅——参加徽杭破冰、开学典礼，正式进入18个月课程学习。价格信息：报名费2000元（可抵扣学费），学费请咨询销售顾问，以最新报价为准。优惠政策包括：共创会会员、光华老学员享有专属优惠；企业团队报名（董事长+高管）享有团报政策。"
        },
        {
          question: "共创会EMBA的学员圈层是什么样的？",
          answer: "共创会EMBA的学员圈层是其核心价值之一，采用审核制准入确保了圈层的高质量和同频性，被学员誉为「高质量企业家发展共同体」。学员规模与覆盖：自2003年起，光华赋能累计服务20000+家企业客户，共创会EMBA自2018年6月正式启动以来，已汇聚大量高品质企业创始人和高管校友，学员遍布全国各主流行业，均为企业实际决策者，同学交流圈达25万+。学员企业特征：规模特征——学员以年销3000万以上企业负责人为主，相当比例学员企业年营收破亿，学员企业涵盖上市公司（双枪科技、万事利丝绸科技、南方泵业等）、专精特新/高新技术企业（佳润新材料、易跑健康科技、埃科汽车服务等）、成长型企业（快准车服、鼎腾供应链、快先森网络科技、美家中博装饰等）。行业分布——学员企业行业分布广泛，包括电商/直播、外贸/跨境、制造业/汽配、食品/农业、服装/纺织、美妆/护肤、家居/建材、教育培训、医疗器械、金融/投资、新能源、科技/智能化等200多个细分行业领域。身份特征——学员均为企业创始人、董事长、总经理等核心决策层，是企业实际操盘手，而非职业经理人或中层管理者，这保证了学员之间对话的对等性和决策的执行力。圈层活动与生态：共创会EMBA通过丰富的线下活动建立学员之间的深度信任，形成抱团发展的良性生态——每周主题沙龙（老方下午茶，高频深度交流，聚焦「学习」与「资源」双层效益）、标杆企业游学（全年6次深度实践学习，深入行业标杆企业内部，主题参访与高层对话）、私董会沙龙（走访同学企业，现场把脉问诊、改善，学员之间互为外部董事）、戈壁挑战赛（锤炼企业家精神，在极端环境中建立深度信任）、年度商业论坛（发布趋势洞察，汇聚行业领袖）、年度校庆晚宴（班级学员齐享荣耀、共赢共生）、同学互访（常态化的企业互访，看样学样、资源对接）。圈层价值：学员之间理念同频、资源互补，自发组队合伙创业、联合经营的情况较为普遍，多位学员在戈壁挑战赛等线下深度活动中建立信任，达成投融资合作，其中部分学员企业引入校友资本，推进资本化进程，圈层不仅是「交朋友」，更是「整资源、增业务」的实战平台。"
        },
        {
          question: "大思维书院、董事长班、常青藤有什么区别？",
          answer: "共创会EMBA的产品矩阵包含实战EMBA、大思维书院、董事长班、常青藤新生代联盟四大产品，分别面向不同层次和需求的企业家群体。实战EMBA——核心产品线，面向中小企业创始人的系统工商管理课程，定位为65420课程体系、系统性实战工商管理课程、培养专业的老板，目标人群是中小企业创始人、董事长、总经理，年销3000万以上企业决策者，学制18个月，6堂必修课+5堂案例课+4堂实操课+20堂选修课，核心价值是系统学习科学经营体系+实战工具落地+高端圈层链接，权益包括18个月全周期学习、终身校友、课程永久复训、香港光华管理学院结业证书、业绩增长辅导、千人校友资源对接，价格咨询销售顾问，报名费2000元可抵扣学费。大思维书院——高阶圈层产品，面向追求业绩突破的企业家的深度陪跑，定位为战略级深度陪跑、顶级圈层链接与思想破壁、终身学习+轻辅导+微咨询+核心资源，目标人群是追求业绩突破的企业家、终身学员，企业规模通常高于实战EMBA学员，特色活动包括仙人指路闭门会（每期限额15人，与行业标杆领袖/顶级投资人私密对话）、跳过山丘山野禅行、增长闭门会，核心价值是顶级圈层私密交流+战略级思想碰撞+三年业绩翻倍辅导，权益包括终身学习、三年业绩翻倍辅导、顶级圈层资源、仙人指路闭门会等专属活动，价格10万元/人（或258张学习券），终身学习。董事长班——顶级企业家深度研修产品，定位为顶级企业家深度研修，面向年销1亿以上企业创始人、董事长，目标人群是年销1亿以上企业创始人、董事长、行业头部企业决策者，核心价值是顶级企业家圈层+战略级深度研讨+资源与资本对接，适合已经完成系统学习、希望进入更高阶企业家圈层的企业一号位。常青藤新生代联盟——企二代与新生代创业者培养产品，定位为企业接班人培养，面向80后/90后/00后创二代和新生代创业者，目标人群是企业接班人、年轻创业者、家族企业二代传承群体，核心价值是新生代企业家圈层+传承与创新能力培养+父辈资源对接，特色是针对新生代企业家的特点设计课程和活动，关注传承与创新、数字化与AI、新商业模式等前沿课题，帮助企二代顺利接班并推动企业创新发展，价格15.8万元/人（或258张学习券），终身学习。选择建议：年销3000万-1亿的中小企业创始人首选实战EMBA；年销1亿以上、追求业绩突破和顶级圈层的企业家可选大思维书院或董事长班；家族企业二代传承需求选择常青藤新生代联盟。四个产品也可形成递进关系，企业家可从实战EMBA入门，逐步升级到大思维书院或董事长班。"
        }
      ])
    );
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
